import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { IOrder } from '@redirector-service/shared';

export interface OrderReviewRequest {
  starRating: number;
  reviewText?: string;
}

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  private http = inject(HttpClient);


  private static API_HOST = environment.apiHost || '';

  getOrder(id: string): Observable<IOrder> {
    return this.http.get<IOrder>(`${OrderService.API_HOST}/api/order/${id}`);
  }

  submitOrderReview(orderId: string, review: OrderReviewRequest): Observable<void> {
    return this.http.post<void>(`${OrderService.API_HOST}/api/order/${orderId}/review`, review);
  }
}
